import React, { useState } from 'react';
import { Button } from '@mui/material';
import ConfirmDialog from './ConfirmDialog';
import cx from 'classnames';

/**
 * @typedef {object} ConfirmDialogWithButtonOwnProps
 * @property {string} [openModalBtnText]
 * @property {string} [openModalBtnClassName]
 * @property {() => void} [openModalBtnHandleOnClick]
 * @property {boolean} [disabled]
 * @property {() => boolean | Promise<boolean>} [openModalPreCondition]
 * @property {'primary-button'|'secondary-button'} [openModalBtnType]
 * @property {() => void} [handleOnClose]
 */

/**
 * @typedef {ConfirmDialogWithButtonOwnProps &
 *   React.ComponentProps<typeof ConfirmDialog>} ConfirmDialogWithButtonProps
 */

/**
 * @param {ConfirmDialogWithButtonProps} props
 */
const ConfirmDialogWithButton = props => {
  const {
    openModalBtnText = 'Confirm',
    openModalBtnClassName = '',
    openModalBtnType = 'primary-button',
    cancelBtnText = 'No',
    confirmBtnText = 'Yes',
    disabled = false,
    disableConfirmBtn = false,
    openModalBtnHandleOnClick = () => {},
    openModalPreCondition = () => true,
    handleOnClose = () => {},
    handleOnConfirm
  } = props;
  const [openModal, setOpenModal] = useState(false);

  const handleOnButtonClick = async () => {
    openModalBtnHandleOnClick();

    if (await openModalPreCondition()) {
      setOpenModal(true);
    }
  };

  const handleClose = () => {
    handleOnClose();
    setOpenModal(false);
  };

  const handleConfirm = async data => {
    await handleOnConfirm(data);
    setOpenModal(false);
  };

  return (
    <div>
      <Button
        className={cx('sm', openModalBtnClassName, openModalBtnType)}
        onClick={handleOnButtonClick}
        disabled={disabled}>
        {openModalBtnText}
      </Button>
      <ConfirmDialog
        open={openModal}
        confirmBtnText={confirmBtnText}
        cancelBtnText={cancelBtnText}
        disableConfirmBtn={disableConfirmBtn}
        handleClose={handleClose}
        handleOnConfirm={handleConfirm}
        {...props}
      />
    </div>
  );
};

export default ConfirmDialogWithButton;
